import { MessageCircle } from "lucide-react";
import { SITE } from "@/config/site";
import { ChapterHeading } from "@/components/ChapterHeading";
import { Reveal } from "@/components/Reveal";
import { StarOrnament } from "@/components/Ornament";
import { trackEvent } from "@/lib/analytics";

function buildShareMessage() {
  const v = SITE.venue;
  const lines = [
    `${SITE.eventName} — ${SITE.tagline}`,
    `Date: ${SITE.date} · Show ${SITE.schedule.show}`,
    `Venue: ${v.name}, ${v.area}, ${v.city}`,
    `Tickets from ₹${SITE.priceFrom} on BookMyShow`,
    `Details: ${SITE.domain}`,
  ];
  return lines.join("\n");
}

export function ShareSection() {
  const share = () => {
    trackEvent("whatsapp_click");
    trackEvent("share_click", { method: "whatsapp" });
    const url = `https://wa.me/?text=${encodeURIComponent(buildShareMessage())}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="share" data-testid="share-section" className="relative px-5 py-20 sm:px-8 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-3xl text-center">
        <ChapterHeading number="09" title="Share With Family &amp; Friends" center testId="share-heading" />

        {/* Small ornamental flourish/diamond divider — the same motif already
            documented as part of the brand's own logo mark, reused here to
            give this shorter chapter a more deliberate, finished feel without
            adding any new copy. */}
        <Reveal delay={0.06}>
          <div className="mx-auto mt-6 flex items-center justify-center gap-3" aria-hidden="true">
            <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#D4AF37]/60" />
            <StarOrnament className="h-4 w-4 text-[#D4AF37]/60" />
            <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#D4AF37]/60" />
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="font-accent mx-auto mt-8 max-w-xl text-lg italic leading-relaxed text-[#C8C2B7] sm:text-xl">
            Some evenings are meant to be shared. Send Chitti Ayee Hai to the people you would want
            beside you in the mehfil.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-10">
            <button
              type="button"
              data-testid="whatsapp-share-btn"
              onClick={share}
              className="btn-gold inline-flex min-h-[56px] items-center justify-center gap-3 rounded-full px-10 text-base font-semibold uppercase tracking-[0.12em] text-[#0A0805] transition-[transform,box-shadow,background-position] duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E6CA65] focus-visible:ring-offset-2 focus-visible:ring-offset-[#080705] active:scale-[0.98] sm:text-lg"
            >
              <MessageCircle className="h-5 w-5" aria-hidden="true" />
              Share on WhatsApp
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
